import React, { createContext, useContext, useEffect, useState } from 'react';
import { getPublicControlPanelName } from '../../../api/system/systemStatus';

export const DEFAULT_CONTROL_PANEL_NAME = 'Neat Schedule Control';
const POLL_MS = 12000;

const ControlPanelBrandingContext = createContext({
  name: DEFAULT_CONTROL_PANEL_NAME,
});

export const useControlPanelBranding = () => useContext(ControlPanelBrandingContext);

export const ControlPanelBrandingProvider = ({ children }) => {
  const [name, setName] = useState(DEFAULT_CONTROL_PANEL_NAME);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const next = String(await getPublicControlPanelName() || '').trim();
        if (!cancelled) setName(next || DEFAULT_CONTROL_PANEL_NAME);
      } catch (error) {
        console.error('Error loading control panel branding:', error);
      }
    };

    load();
    const timer = setInterval(load, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  return (
    <ControlPanelBrandingContext.Provider value={{ name }}>
      {children}
    </ControlPanelBrandingContext.Provider>
  );
};
